<template>
  <div class="content">
	<app-header></app-header>    
    <div class="identityBg">
    	<img src="../../assets/imgs/identityBg.png" alt="" />
    </div>
    <div class="identMsg">
    	<h2>完成招聘者身份审核</h2>
    	<div class="idengtEdit clearfix">
    		<div class="companyEdit fl">
    			<h3>单位信息</h3>
    			<!--<p class="companyLogo"><span class="editTitle">公司LOGO</span><label><img v-bind:src="logo" alt="" /><input  type="file"  @change="uploadLOGO()" id="saveImage" name="logo" /></label>支持jpg、jpeg、gif、pdf、png格式文件不超过10M</p>-->
    			<p class="basicMsg"><span class="importants">&lowast;</span><span class="editTitle">单位名称</span><input v-model = "companyName" placeholder="请输入单位名称" type="text" /></p>
    			<p class="basicMsg"><span class="importants">&lowast;</span><span class="editTitle">单位地址</span><input v-model = "companyAdd" placeholder="请输入单位地址" type="text" /></p>
    			<p class="basicMsg"><span class="importants">&lowast;</span><span class="editTitle">上传营业执照或其他证明材料</span></p>
    			<div class="uploadMsg clearfix">
    				<div class="uploads fl">
    					<p>请上传</p>
    					<label>
    						<img v-bind:src="businessLic" alt="科研人才网-高校教师硕士博士科研招聘平台" />
    						<input  type="file"  @change="businessLicenseTypeLi()" id="savebusinessLic" name="businessLic" />
    					</label>
    				</div>
    				<div class="example fl">
    					<p>示范</p>
						<img src="../../assets/imgs/recruiter.png" alt="科研人才网-高校教师博士科研人才招聘" />
    				</div>
    			</div>
    			
    		</div>
    		<div class="personalEdit fl">
    			<h3>个人信息</h3>
    			<p class="basicMsg"><span class="importants">&lowast;</span><span class="editTitle">姓名</span><input v-model = "recruitmentName" placeholder="请输入姓名" type="text" /></p>
    			<p class="basicMsg"><span class="importants">&lowast;</span><span class="editTitle">职务</span><input v-model = "recruitmentPosition" placeholder="请输入职务" type="text" /></p>
    			<p class="basicMsg"><span class="importants">&lowast;</span><span class="editTitle">手机号</span><input v-model = "telPhoneNo" maxlength="11"  @blur="checkPhoneNum()" placeholder="请输入手机号" type="text" /></p>
    			<p class="basicMsg"><span class="importants">&lowast;</span><span class="editTitle">手持身份证上传照片</span></p>
    			<div class="uploadMsg clearfix">
    				<div class="uploads fl">
    					<p>请上传</p>
    					<label>
    						<img v-bind:src="cardNoSrc" alt="科研人才网-本科高校教师博士科研人才招聘" />
    						<input  type="file"  @change="cardNo()" id="saveCardNo" name="CardNo" />
    					</label>
    				</div>
    				<div class="example fl">
    					<p>示范</p>
    					<img src="../../assets/imgs/businessLicense.png" alt="科研人才网-高校教师博士科研岗位人才招聘" />
    				</div>
    			</div>
    		</div>
    		<p class="prompt fl"><span>提示：</span>1、注册邮箱既接收简历邮箱：{{userName}}；&nbsp;&nbsp;&nbsp;2、身份证原件信息需清晰可识别；&nbsp;&nbsp;&nbsp;3、身份证原件信息完整展示、请勿遮挡、PS</p>
    		<p class="fl submits"><span @click="submitReview">提交审核</span></p>
    	</div>
    </div>
	<div class="ident">
		<app-footer></app-footer>
	</div>
  </div>
</template>

<script> 
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header1.vue'
import {get, postWithJson, form} from '@/api/services'
export default {
  name: 'identityReview',
  components: {AppFooter,AppHeader },
    data () {
    	return {
      		userId:'', //user_id
      		id:0,//用户id
			userName:'',//
			cardNoSrc:require('../../assets/imgs/credentialsbg.png'),
			businessLic:require('../../assets/imgs/credentialsbg.png'),
      		companyName:'',//公司名称
      		companyAdd:'',// 公司地址
      		recruitmentName:'',//招聘者姓名
      		recruitmentPosition:'',//招聘者职务
      		telPhoneNo:'',//手机号
			businessLicFlag:false,//是否上传营业执照
			cardNoSrcFlag:false,//是否上传身份证
			  
			//设置公司页数据
			logo:"",
			logoFlag:false,
			companyName:'',//公司名称
			companyUrl:'',//公司网站
			shortName:'',//公司简称
			// companyType:"",//单位类型
			companyEnvir1:require("../../assets/imgs/addEnvironment.png"),
			companyEnvir2:require("../../assets/imgs/addEnvironment.png"),
			companyEnvir3:require("../../assets/imgs/addEnvironment.png"),//
			companyEnvir1Flag:false,
			companyEnvir2Flag:false,
			companyEnvir3Flag:false,
			editorText:'',//公司简介
			telPhone:'',//手机号
			email:'',//邮箱
			noNowStatue:true,//是否通过认证
    	}
	  },
	mounted:function(){
		this.getCompanyInfo(); //获取userid
	},
	methods:{
		getCompanyInfo:function(){
			let _self = this;
			_self.userName = localStorage.getItem('_userName');	
			postWithJson('front/user/getCompanyInfo',{email:_self.userName}).then(
				function(response) {
					if(response.data.status){
						let resData = response.data.data;
						_self.userId = resData.userId;
						_self.id = resData.id;
						_self.companyName = resData.name;
						_self.companyAdd =resData.address;
						_self.businessLic = resData.businessPhone||require('../../assets/imgs/credentialsbg.png');
						_self.recruitmentName = resData.contactName;
						_self.recruitmentPosition = resData.position;
						_self.telPhoneNo = resData.tel;
						// _self.cardNoSrc = resData.certificate||require('../../assets/imgs/credentialsbg.png');
						_self.cardNoSrc = resData.idCradPhoto||require('../../assets/imgs/credentialsbg.png');
						_self.logo = resData.logo||require("../../assets/imgs/LOGOThumbnail.png");
						_self.shortName = resData.shortName;
						_self.companyUrl = resData.web;
						_self.telPhone = resData.tel;
						//  公司环境
						if(resData.photo != null && resData.photo != "" && resData.photo != undefined){
							if(resData.photo[0] != undefined){
								_self.companyEnvir1 = resData.photo[0];
								_self.companyEnvir1Flag = true;
							}
							if(resData.photo[1] != undefined){
								_self.companyEnvir2 = resData.photo[1];
								_self.companyEnvir2Flag = true;
							}
							if(resData.photo[2] != undefined){
								_self.companyEnvir3 = resData.photo[2];
								_self.companyEnvir3Flag = true;
							}
						}
						_self.editorText = resData.description;

					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					_self.$message({
						message: "请重试！",
						type: 'error'
					});           
				}
			)			
		},
		checkPhoneNum:function(){
			let _self = this;
			let myreg = /^1\d{10}$/;
			if (!myreg.test(parseInt(_self.telPhoneNo))) {
				_self.$message({
						message: "请输入正确的手机号！",
						type: 'error'
					});  
			} 
		},
		businessLicenseTypeLi:function(){  //营业执照
			let _self = this;
			let x = document.getElementById('savebusinessLic').files[0];
			let params = new FormData() ; //创建一个form对象
			params.append('file',x,x.name);  //append 向form表单添加数据
			let config = {
				headers:{'Content-Type':'multipart/form-data'}
			};
			postWithJson("front/common/upload",params,config)
				.then(function(response){
					if(response.data.code == 0){
						_self.businessLicFlag = true;
						_self.businessLic = response.data.url;
					}else{
						_self.$message({
							message: response.data.msg,
							type: 'error'
						});
					}          
				},
			function(response) {
					_self.$message({
						message: "请重试！",
						type: 'error'
					});            
			})
		},
		cardNo:function(){  //身份证
			let _self = this;
			let x = document.getElementById('saveCardNo').files[0];
			let params = new FormData() ; //创建一个form对象
			params.append('file',x,x.name);  //append 向form表单添加数据
			let config = {
			headers:{'Content-Type':'multipart/form-data'}
			};
			postWithJson("front/common/upload",params,config)
			.then(function(response){
				if(response.data.code == 0){
					_self.cardNoSrcFlag = true;
					_self.cardNoSrc = response.data.url;
				}else{
					_self.$message({
						message: response.data.message,
						type: 'error'
					});
				}          
			},
			function(response) {
				_self.$message({
					message: "请重试！",
					type: 'error'
				});            
			})
		},
		submitReview:function(){  //提交审核
			var _self = this;
			if(_self.companyName == ""){
				_self.$message({
					message: "请输入单位名称",
					type: 'error'
				});
				return false;
			}
			if(_self.companyAdd == ""){
				_self.$message({
					message: "请输单位地址",
					type: 'error'
				});
				return false;
			}    
			
			if(_self.recruitmentName == ""){
				_self.$message({
					message: "请输入个人姓名",
					type: 'error'
				});
				return false;
			}
			if(_self.recruitmentPosition == ""){
				_self.$message({
					message: "请输入个人职务",
					type: 'error'
				});
				return false;
			}
			if(_self.telPhoneNo == ""){
				_self.$message({
					message: "请输入手机号",
					type: 'error'
				});
				return false;
			}
			let myreg = /^1\d{10}$/;
			if (!myreg.test(parseInt(_self.telPhoneNo))) {
				_self.$message({
					message: "请输入正确的手机号！",
					type: 'error'
				});
				return false;
			} 
			let environmentList = "";
			if(_self.companyEnvir1Flag){
				environmentList += _self.companyEnvir1;
			}
			if(_self.companyEnvir2Flag){
				if(_self.companyEnvir1Flag){
					environmentList += ';'+_self.companyEnvir2;
				}else{
					environmentList += _self.companyEnvir2;
				}
			}
			if(_self.companyEnvir3Flag){
				if(_self.companyEnvir1Flag || _self.companyEnvir2Flag){
					environmentList += ';'+_self.companyEnvir3;
				}else{
					environmentList += _self.companyEnvir3;
				}
			}
			let datas = {
				id:_self.id,
				userId:_self.userId,
				contactName:_self.recruitmentName,//联系人姓名
				job:"",//职位
				name:_self.companyName,
				shortName:_self.shortName ||"",
				tel:_self.telPhoneNo,
				email:_self.userName,
				logo:"",
				web:_self.companyUrl||"",
				city:'',
				position:_self.recruitmentPosition,
				department:"",
				scale:'',
				stage:'',
				description:_self.editorText||"",
				businessPhone:_self.businessLic,
				address:_self.companyAdd,
				photo:environmentList,
				status:1,
				certificate:"",
				idCradPhoto:_self.cardNoSrc,
			}
			postWithJson('front/companyInfo/updateCompanyInfo',datas).then(
				
					function(response) {
					if(response.data.status){
						_self.$message({
							message: '您的信息已提交成功',
							type: 'success'
						});
						_self.$router.push({ path:'/setCompany'})
					}else{
						_self.$message({
							message: response.data.message,
							type: 'error'
						});
					}
				},
				function(response) {
					_self.$message({
						message: "请重试！",
						type: 'error'
					});
				}
			)
		}
	},

	
}
</script>

<style  lang = "less"  scoped="scoped" >
//滚动条
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #f1f1f1;
}

//滚动条轨道 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px #f1f1f1;
    -moz-box-shadow: inset 0 0 6px #f1f1f1;
    box-shadow: inset 0 0 6px #f1f1f1;
    background-color: #f1f1f1;
}

//滑块
::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px #c1c1c1;
    -moz-box-shadow: inset 0 0 6px #c1c1c1;
    box-shadow: inset 0 0 6px #c1c1c1;
    border-radius: 3px;
    background-color: #c1c1c1;
}
.content{
	width: 100%;
	height: 1080px;
	position: relative;
	background-color: #f8f9fc;
	.identityBg{
		position: relative;
		width: 100%;
		img{
			width: 100%;
			height: 228px;
		}
	}
	.example{
		img{
			margin-top:6px;
		}
	}
	.identMsg{
		width: 1200px;
		height: 978px;
		position: absolute;
		left: 50%;
		margin-left: -600px;
		top: 0px;
		h2{
			text-align: center;
			color: white;
			font-size: 46px;
			margin: 130px auto 40px;
		}
		.idengtEdit{
			background-color: white;
			width: 1200px;
			height: 798px;
			border: 1px solid #d4dae4;
			box-sizing: border-box;
			padding: 40px;
			.companyEdit,.personalEdit{
				width: 50%;
				box-sizing: border-box;
				height: 560px;	
				h3{
					font-size: 24px;
					color: #444444;
				}
				input[type = 'text']{
					width: 400px;
					height: 44px;
					border: none;
					background-color: #f8f8f8;
					text-indent: 10px;
				}
				.companyLogo{
					font-size: 12px;
					color: #878787;
					margin-top: 10px;
					vertical-align: top;
					label{
						display: inline-block;
						width: 72px;
						height: 66px;
						margin-left: 12px;
						margin-right: 4px;
						border: none;
						cursor: pointer;
					}
					.editTitle{
						vertical-align: top;
					}
					img{
						vertical-align: top;
						width: 72px;
						height: 66px;
					}
					input{
						visibility: hidden;
						width: 0;
						height: 0;
					}
				}
				.basicMsg{
					height: 68px;
					line-height: 68px;
				}
				.editTitle{
					display: inline-block;
					font-size: 14px;
					color: #444;
					min-width: 100px;
					text-align: left;
				}
				.importants{
					color: red;
					margin-right: 4px;
				}
				.uploadMsg{
					padding-left: 110px;
					vertical-align: top;
					p{
						font-size: 14px;
						width: 154px;
						color: #444;
						height: 24px;
						line-height: 24px;
						text-align: center;
					}
					label{
						display: inline-block;
						width: 154px;
						height: 220px;
						margin-right: 22px;
						margin-top: 6px;
						cursor: pointer;
					}
					img{
						width: 154px;
						height: 220px;
					}
					input{
						visibility: hidden;
						width: 0;
						height: 0;
					}
				}			
			}
			.companyEdit{
				border-right: 1px solid #d4dae4;
			}
			.personalEdit{
				padding-left: 40px;
			}
			.prompt{
				width: 1132px;
				height: 62px;
				line-height: 62px;
				border: 1px solid #d4dae4;
				font-size: 14px;
				color: #444;
				background-color: #fdf7db;
				text-indent: 52px;
				margin-top: 20px;
				span{
					color: #da251d;
				}
			}
			.submits{
				text-align: center;
				margin-top: 32px;
				width: 100%;
				position: relative;
				span{
					position: absolute;
					left: 50%;
					margin-left: -141px;
					display: inline-block;
					background-color: #da251d;
					color: white;
					width: 282px;
					height: 52px;
					line-height: 52px;
					font-size: 21px;
					cursor: pointer;
				}
			}
		}
	}
	.ident{
		margin-top: 770px;
	}	
}
</style>



// WEBPACK FOOTER //
// src/views/companyRegister/identityReview.vue